import React from "react";
import { useHistory } from "react-router-dom";
import { Shortcut } from "../../../../application/domain/ttzk-portal";
import { useAuthContextV2 } from "../../../../auth-state";
import PublishStatusTag from "../../../atoms/ttzk-portal/publish-status-tag";
import { TtzkPortalR } from "../../../pages/ttzk-portal/route";

type Props = {
  shortcuts: Shortcut[];
};

export const ShortcutsTable: React.FC<Props> = ({ shortcuts }) => {
  const { auth } = useAuthContextV2();
  const history = useHistory();
  const sortedShortcuts = shortcuts.sort((a, b) => a.priority - b.priority);

  return (
    <>
      {auth.isPortalStandardPlan() && (
        <div>
          <table className="table is-fullwidth">
            <thead>
              <tr>
                <th>ショートカットID</th>
                <th>ショートカット名</th>
                <th>優先度</th>
                <th>公開ステータス</th>
              </tr>
            </thead>
            <tbody>
              {sortedShortcuts.length > 0 &&
                sortedShortcuts?.map((shortcut) => (
                  <tr
                    key={shortcut.id}
                    className="c-tr-selectable c-tr-has-tag"
                    onClick={() =>
                      history.push(
                        TtzkPortalR.ShortcutDetail.link({
                          shortcutId: shortcut.id,
                        }),
                      )
                    }
                  >
                    <td>{shortcut.id}</td>
                    <td>{shortcut.name}</td>
                    <td>{shortcut.priority}</td>
                    <td>
                      <PublishStatusTag shortcut={shortcut} />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default ShortcutsTable;
